import { render, staticRenderFns } from "./EditDriverDetailsModal.vue?vue&type=template&id=74371076&scoped=true"
import script from "./EditDriverDetailsModal.vue?vue&type=script&lang=js"
export * from "./EditDriverDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74371076",
  null
  
)

export default component.exports